import config from 'config'

import { AbstractService } from 'shared/services/AbstractService'
import { SCENE_SOUCE } from '~/shared/constants'
import getLogger from 'shared/logger'
import { stringifyArrayFormatRepeat } from '~/shared/url'

const DEFAULT_PRODUCT_VARIATIONS_QUERY = {} as ProductVariations.ProductVariationsQuery

export class ProductVariationsApi extends AbstractService implements Services.IProductVariationsService {
  public async getProductVariations(query = DEFAULT_PRODUCT_VARIATIONS_QUERY): Promise<ProductVariations.Response> {
    const { templateToken, locale, offset, limit, selectedOptions, noCache, useConstraints, mpvId, searchBackend, debug, productKeys } = query
    const url = `v2/Designs/${templateToken}/Culture/${locale}/ProductVariations`
    const selectedOptionsObj: Util.StringDictionary<string> = {}

    Object.entries(selectedOptions).forEach(([key, value]) => {
      const objKey = `selectedOptions[${key}]`

      selectedOptionsObj[objKey] = value as string
    })

    const paramsConfig = {
      offset,
      limit,
      requestor: noCache ? config.noCacheRequestor : config.appName,
      noCache,
      useConstraints,
      mpvId,
      includeColorSwatches: true,
      includePreview: true,
      sceneSource: SCENE_SOUCE.SCENE_LOOKUP_SOURCED,
      searchBackend,
      debug,
      productKeys,
      ...selectedOptionsObj,
    }

    const { data } = await this.api.get<ProductVariations.Response>(url, {
      params: {
        ...paramsConfig,
      },
      paramsSerializer: stringifyArrayFormatRepeat,
    })

    return data
  }
}

export const ProductVariationsService = new ProductVariationsApi(config.services.designVariationsService, getLogger)
